const state = {
    count: 0,
    solutions: []
};
const mutations = {
    add(state, item) {
        state.count = item.count;
        state.solutions.push(item.stack);
    }
};
const getters = {
    count: (state) => state.count,
    solutions: (state) => state.solutions
};
const actions = {
    add({ commit }, item) {
        commit('add', item);
    }
};
export const Pentomino = {
    namespaced: true,
    state,
    mutations,
    getters,
    actions
};
